

<template>
    <div > 
        <div id="loading" v-if="showLoading" class="d-flex flex-column " style="height:unset;width:100%;">
            <img
                class="loadingImg mx-auto"
                src="../../assets/images/loading.gif"
                alt="loading..."
                width="200"
                style="position:relative;"
            />
            <span class="mx-auto" @click="Refresh" v-if="ShowRefresh">付款處理中，點此重新刷新...</span>
        </div> 
        
        <div v-html="PayData"></div>
    </div>
</template>
<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'


export default {
    name: 'PayPage',
    components:{Nav},
    data () {
        return {
            showLoading:true,
            ShowRefresh:false,
            PayData:'',
            transactionResult:null,
            payOrderId:'',
            paySendTime:'',
            OrderData:null,
            CheckResponseResultNum:0,
        }
    },
    mounted(){
        //需要開啟監聽POST
        if(document.getElementById("upp")){
            document.getElementById("upp").submit()
        }
    },
    methods:{
        Refresh(){
            this.CheckResponseResultNum = 0
            this.ShowRefresh = false;
            this.CheckResponseResult();
        },
        CheckResponseResult(){
            this.showLoading = true;
            this.CheckResponseResultNum += 1;

            const api =`${process.env.APIPATH}/api/Pay/CheckResponseResult`;
            const inputdata = 
            {
                "payorderid":this.OrderData.payOrderId,
                "paysendtime":this.paySendTime,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    if(response.data.isSuccess){
                        if(response.data.paystate == 3){ // 3:付款失敗 1:付款成功 2:未付款
                            this.showLoading = false;
                            //跳轉付款失敗畫面
                            this.$router.push({
                                name: 'PayFail',
                                params: {
                                    message:response.data.paymessage
                                }
                            });
                        }else if(response.data.paystate == 1){
                            this.showLoading = false;
                            //跳轉付款成功畫面
                            this.$router.push({
                                name: 'PaySuccess',
                                params: {
                                    OrderData:this.$route.params.OrderData,
                                }
                            });
                        }else{
                            if(this.CheckResponseResultNum < 3){
                                setTimeout(() => {
                                    this.CheckResponseResult();
                                },800)
                            }else{
                                this.ShowRefresh = true;
                            }
                        }
                    }else{
                        if(this.CheckResponseResultNum < 3){
                            setTimeout(() => {
                                this.CheckResponseResult();
                            },800)
                        }else{
                            this.ShowRefresh = true;
                        }
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
    },
    created(){
        if(this.$route.params.PayData != undefined){
            this.PayData = this.$route.params.PayData;
        }else{
            this.OrderData = JSON.parse(sessionStorage.getItem('OrderData'));
            this.paySendTime = sessionStorage.getItem('paySendTime');
            this.CheckResponseResult();
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Pay/PayPage.vue